export function enableBodyScroll() {
  document.querySelector("body").classList.remove("disable-scroll")
}

export function disableBodyScroll() {
  document.querySelector("body").classList.add("disable-scroll")
}
